//exported methods for users login, logout and settings

import { getFromServer, postToServer } from "./CommonFunctions";

// check if the user is logged in
export async function loggedIn() {
    var res = false;

    await fetch("/api/forge/oauth/token").then((response) => {
        res = response.ok;
        console.log("response: " + response.result);
    });
    console.log("res: " + res);

    return res;
}

// method to be called when the user press the login button
export async function loginButton(adminPage = false) {
    fetch("/api/forge/oauth/url?admin=" + adminPage)
        .then((response) => {
            return response.text();
        })
        .then((data) => {
            window.location.href = data;
        });
}

// logout method, recieves an hiddren frame for the purpose of autodesk logout implementation
// will recall the site
export async function logout(hiddenFrame, isAdmin = false) {
    hiddenFrame.onload = function (event) {
        window.location.href = "/api/forge/oauth/signout?isAdmin=" + isAdmin;
    };

    hiddenFrame.src = "https://accounts.autodesk.com/Authentication/LogOut";

    // learn more about this signout iframe at
    // https://forge.autodesk.com/blog/log-out-forge
}

//assume user is logged in
/*
 *return object data for getUserData:
 *  newUser - bool, true if this is the user first login and we need to go to create account field
 *  emailId - the email the user used to login to autodesk, don't think you need it right now
 *  picture - url
 *  the next properties will be null if the user is new
 *  name
 *  email
 *  phone
 *  company
 *  role
 *  subscreption: 0-free, 2-Premium
 */
export async function getUserData() {
    var res = await getFromServer("/api/forge/user/profile");
    console.log(res)
    currentUser.userId = res.emailId;
    currentUser.userName = res.name;
    //currentUser.userBimID = res.userId;
    return res;
}

//assume user is logged in
export async function deleteUserData() {
    await fetch("/api/forge/user/delete");
}

//assume user is logged in
export async function setUserData(name, email, phone, company, role) {
    var url = "/api/forge/user/data";
    var data = [];

    currentUser.userName = name;

    data.push(name);
    data.push(email);
    data.push(phone);
    data.push(company);
    data.push(role);

    postToServer(url, data);
}

// Current logged in user
// .userID - user autodesk email id
// .userName - user name
export var currentUser = new Object();
